import React, { Component } from 'react'

import TextBox from '../../../components/TextBox/TextBox';
import BtnGroup from '../components/BtnGroup'

import './steep.scss'
//须知页
export class Steep0 extends Component {
  
  render() {
    var shoudKnow=[
        '1. 本系统推荐的浏览器有：Chrome浏览器，360浏览器。为带来最佳的用户体验，建议您使用Chrome浏览器；',
        '2. 壁报内容由目的、方法、结果、结论四部分组成，请按照顺序依次填写，不得为空，为空则无法提交，全部文字（不包括图片）字数请控制在300-1000字符内；',
        '3. 上传图片，请点击编辑器内左上角图标，图片只支持jpg，jpeg格式，大小请控制在2M以内，请耐心等待图片上传，直到图片上出现对勾符号，即表示图片上传成功；如若还未见到对勾提示就提前关闭页面，图片将上传失败，无法在poster展示；',
        '4. 当目的、方法、结果、结论四部分内容被编辑完成后，请点击“去预览”，方可预览您已经编辑好的壁报内容；',
        '5. 在预览界面，“返回”按钮，可对于壁报内容再次进行编辑；如确认壁报内容无误，请点击“提交”按钮；提交成功后，壁报只可以查阅 ，无法再修改，请严肃认真对待；',
        '6. 如果您的poster内容被大会审核通过，则会被展示在会议现场的poster机器上，如若没有被展示，则是审核未通过。',
    ];
    var QA=[
        'Q：字号如何调整？',
        'A：无需自己调整字体字号，系统自动使用默认字体和字号，后期会有专人负责壁报的编辑排版。',
        'Q：图片上传了看不到显示是怎么回事?',
        'A：有以下可能性：1. 图片格式，请使用jpg格式的图片(2M以内)；2. 在上传图片时，可能提前关闭了上传图片的窗口，造成图片上传失败，重新上传时，图片过大或者网速不好的情况，都会导致上传图片比较慢，请您耐心等待，务必等到图片上出现对勾提示后，再关闭窗口。',
        'Q：为什么我提交了几次都无法成功？',
        'A：有以下可能性：1. 壁报内容由标题、作者、作者单位／机构、目的、方法、结果、结论七部分组成，请按照顺序依次填写，任何部分都不得为空，为空则无法提交；2. 全部文字（不包括图片）字数请控制在300-1000字符内，超过无法提交；',
        'Q：我在哪里看到壁报？',
        'A：1. 填写完之后使用“去预览”功能可以看到自己的壁报；2. 已经编辑了还未提交壁报，再次登录后，在“我投过的稿件”中即可找到自己的壁报内容，也可继续上次编辑内容；3. 已经提交壁报后，在“我投过的稿件”中即可找到自己的壁报内容，由于您已经提交大会，所以壁报内容只可以查阅，无法再进行任何修改。',
        'Q：表格怎样上传？',
        'A：截屏生成图片，把文件保存到电脑里，然后在编辑页面中，点击编辑方框的左上角图标，即可上传图片。',
        'Q：怎样在壁报中上传图片？',
        'A：请点击编辑器内左上角图标，图片只支持jpg，jpeg格式，大小请控制在1M以内，请耐心等待图片上传，直到图片上出现对勾符号，即表示图片上传成功。',
        'Q：壁报为什么还在审核中，什么时候能通过审核？',
        'A：请耐心等中华护理学会审核，最晚在会议开始前完成壁报审核。',
    ]
    var showTips=[
        '请各位会议签到成功的老师，在电子壁报机可查看到审核通过的投稿内容。',
    ]
    return (
      <div className='steep'>
         <TextBox title='壁报编辑器使用方法' content={shoudKnow} />
         <TextBox title='答疑' content={QA} />
         <TextBox title='展示说明' content={showTips} />
         <BtnGroup changeSteep={this.props.changeSteep}/>
      </div>
    )
  }
}

export default Steep0



// WEBPACK FOOTER //
// ./src/routes/editor/steep/steep0.jsx